import { DateTimeOffset } from '@coast/schemas';
import moment from 'moment';
import { useCallback, useMemo } from 'react';
import { View } from '@shared/components/View';
import { MBListRow } from '@shared/components/list/row';
import { SelectableRadioDot } from '@shared/components/list/row/selectable';
import { format } from './hooks';

interface Props {
  selected: boolean;
  title: string;
  onSelect(selected: boolean): void;
}

export function PickerRow({ selected, title, onSelect }: Props) {
  const handleChange = useCallback(() => onSelect(!selected), [onSelect, selected]);
  return (
    <MBListRow
      title={title}
      image={
        <View fill center>
          <SelectableRadioDot selected={selected} radio={false} />
        </View>
      }
      isHidingPressableIndicator
      onPress={handleChange}
    />
  );
}

interface ReminderProps {
  selected: boolean;
  offset: DateTimeOffset;
  onSelect(offset: DateTimeOffset, selected: boolean): void;
}

export function ReminderPickerRow({ selected, offset, onSelect }: ReminderProps) {
  const handleSelect = useCallback(
    (nextSelected: boolean) => onSelect(offset, nextSelected),
    [onSelect, offset],
  );
  const duration = useMemo(() => moment.duration(offset.count, offset.unit), [offset]);
  return <PickerRow selected={selected} title={format(duration)} onSelect={handleSelect} />;
}
